// src/components/sections/CTABanner.js
import React from "react";
import { FaArrowRight } from "react-icons/fa";
import bgImg from "../../Assets/Images/CTAbgImg.jpg";

const CTABanner = () => {
  return (
    <section
      id="scrollToForm"
      className="relative min-h-[800px] flex items-center justify-center text-white"
      style={{
        backgroundImage: `url(${bgImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/60"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center text-center px-4 max-w-5xl">

        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold mb-3">
          Have any projects in mind?
        </h2>

        <h3 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl mb-6 text-white/90">
          Know more about us
        </h3>

        <a
          href="/aboutUs"
          className="group mb-8 flex items-center justify-center w-16 h-16 md:w-20 md:h-20 border border-white/40 rounded-full text-white transition-all duration-300 hover:border-cyan-400 hover:rotate-0 rotate-45"
        >
          <FaArrowRight size={28} className="group-hover:text-cyan-400 transition" />
        </a>

        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-light leading-tight tracking-wide">
          High-Impact <br />
          Outcomes That <br />
          Drive Your Business
        </h1>

        {/* SPACE */}
        <div className="h-8 md:h-12"></div>

        {/* DESCRIPTION */}
        <p className="text-sm sm:text-base md:text-lg text-white/80 leading-relaxed max-w-3xl">
          In today’s fast-paced world, efficiency is paramount. We leverage best-in-class talent
          and cutting-edge technology to expedite your digital journey.
        </p>

      </div>
    </section>
  );
};

export default CTABanner;
